import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "download-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M12 2.25C12.4142 2.25 12.75 2.58579 12.75 3V15.1893L16.4697 11.4697C16.7626 11.1768 17.2374 11.1768 17.5303 11.4697C17.8232 11.7626 17.8232 12.2374 17.5303 12.5303L12.5293 17.5313C12.3887 17.672 12.1979 17.751 11.999 17.751C11.8 17.751 11.6093 17.672 11.4686 17.5313L6.46862 12.5303C6.17575 12.2374 6.1758 11.7625 6.46872 11.4696C6.76165 11.1768 7.23652 11.1768 7.52938 11.4697L11.25 15.1911V3C11.25 2.58579 11.5858 2.25 12 2.25Z" }, null, -1),
    _createElementVNode("path", { d: "M3.25 20.5C3.25 20.0858 3.58579 19.75 4 19.75H20C20.4142 19.75 20.75 20.0858 20.75 20.5C20.75 20.9142 20.4142 21.25 20 21.25H4C3.58579 21.25 3.25 20.9142 3.25 20.5Z" }, null, -1)
  ])))
}
export default { render: render }